


import { FontAwesomeIcon, } from '@fortawesome/react-fontawesome';
import { fab,faFacebook, faTwitter,faInstagram,faYoutube, faLinkedin } from '@fortawesome/free-solid-svg-icons'
import {faChartLine,faClock,faStar,faTools,faUserShield ,faTimes,faBars } from '@fortawesome/free-solid-svg-icons'
import { Link } from "react-router-dom";

import "./AlsoUs.css"

function AlsoUs(){  
    return <>
    <div className="AlsoUsCover">


            <div className="AlsoUsCoverforeword">

                        <h2>Wait, we do more!</h2>
                        
            </div>

            <div className="AlsoUsChartcardsCover">
            <div className="AlsoUsChartcards">

                        <div className="AlsoUsChart">

                                <div className="AlsoUsIcon">

                                   <FontAwesomeIcon className='AlsoUsIcons' icon={faChartLine} />

                                </div>
                                <div className="Wording">
                                        <p>Analytics & Reporting</p>
                                </div>

                        </div>
                        <div className="AlsoUsChart">

                                <div className="AlsoUsIcon">

                                      <FontAwesomeIcon className='AlsoUsIcons' icon={faStar} />

                                </div>
                                <div className="Wording">
                                        <p>Performance management</p>
                                </div>

                        </div>
                        <div className="AlsoUsChart">

                                <div className="AlsoUsIcon">

                                          <FontAwesomeIcon className='AlsoUsIcons' icon={faClock} />

                                </div>
                                <div className="Wording">
                                        <p>Time tracking</p>
                                </div>

                        </div>
                        
            </div>
            </div>

                       

     
        </div>
        
    </>

}

export default AlsoUs;